import React, { useEffect, useState } from "react";
import { Ok } from "react-ikonate";
import styles from "./Checkbox.module.css";
import classNames from "classnames";

/**
 * A basic HTML checkbox with built in styles.
 */
export function Checkbox({ className, isChecked = false, onChange, ...props }) {
  const [checked, setChecked] = useState(isChecked);

  useEffect(() => {
    setChecked(isChecked);
  }, [isChecked]);

  const handleChange = (event) => {
    setChecked(event.target.checked);
    onChange?.(event);
  };

  return (
    <div className={styles.container}>
      <input
        type="checkbox"
        className={classNames(styles.checkbox, className)}
        {...props}
        checked={checked} // Use the controlled checked state
        onChange={handleChange} // Handle changes
      />

      {checked && (
        <div className={styles.icon}>
          <Ok />
        </div>
      )}
    </div>
  );
}
